export const demoLogins = {
    ru: "oosys_demo_ru",
    en: "oosys_demo_en",
    sp: "oosys_demo_sp",
    pt: "oosys_demo_pt",
    ch: "oosys_demo_ch",
    fr: "oosys_demo_fr",
    vi: "oosys_demo_vn",
    kz: "oosys_demo_kz"
} as const;

export type DemoLang = keyof typeof demoLogins;